/* src/app/pages/landing/landing.component.scss */
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
.button {
  font-family: "Lato-Regular", serif;
  font-size: 18px;
  text-decoration: none;
  display: inline-block;
  margin: 5px;
  width: 290px;
  height: 50px;
  border-radius: 26px;
  border: none;
  padding: 10px;
  color: #5F96BA;
  outline: none !important;
}
.button:disabled {
  box-shadow: none;
  background-color: #BCBCBD !important;
  color: #797A7B !important;
  border: none;
}
.button:disabled:hover {
  box-shadow: none;
}
.button-default {
  outline: none !important;
  background-color: white;
  color: #5F96BA;
  border: 1px solid #5F96BA;
}
.button-default:hover {
  color: #284D76;
  background-color: #9FC6D8;
  border-color: #9FC6D8;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
.button-active {
  background-color: #5F96BA;
  color: #FFF;
}
.button-active:hover {
  background-color: #9FC6D8;
  color: #284D76;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
.button-disabled {
  background-color: #BCBCBD !important;
  color: white !important;
  border: none;
}
.button-disabled:hover {
  box-shadow: none;
}
.button-gradient {
  outline: none !important;
  background-image:
    linear-gradient(
      270deg,
      #171C8F,
      #00B7BD);
  color: white;
  border: none;
}
.button-gradient:hover {
  outline: none !important;
  box-shadow: 0px 8px 8px rgba(23, 28, 143, 0.1490196078);
}
@media screen and (max-width: 1000px) {
  .button {
    width: 275px;
    font-size: 15px;
  }
}
@keyframes ldio-okxz8jkbhq-1 {
  0% {
    top: 12.5px;
    height: 75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-2 {
  0% {
    top: 15.625px;
    height: 68.75px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
@keyframes ldio-okxz8jkbhq-3 {
  0% {
    top: 18.75px;
    height: 62.5px;
  }
  50% {
    top: 25px;
    height: 50px;
  }
  100% {
    top: 25px;
    height: 50px;
  }
}
.ldio-okxz8jkbhq div {
  position: absolute;
  width: 12px;
}
.ldio-okxz8jkbhq div:nth-child(1) {
  left: 19px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-1 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.2s;
}
.ldio-okxz8jkbhq div:nth-child(2) {
  left: 44px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-2 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: -0.1s;
}
.ldio-okxz8jkbhq div:nth-child(3) {
  left: 69px;
  background: #f2d155;
  animation: ldio-okxz8jkbhq-3 1s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  animation-delay: undefineds;
}
.loadingio-spinner-pulse-uq8kufhdmv {
  width: 100px;
  height: 100px;
  display: inline-block;
  overflow: hidden;
  background: none;
}
.ldio-okxz8jkbhq {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0;
}
.ldio-okxz8jkbhq div {
  box-sizing: content-box;
}
._tooltip {
  display: none;
  position: absolute;
  margin-top: 14px;
  font-family: "Helvetica Neue", serif;
  font-size: 13px;
  background-color: #00b7bd;
  padding: 7px;
  color: #FFF;
}
.input-group-title {
  color: #284D76;
  font-size: 22px;
  font-family: "Gotham-Bold", serif;
  font-weight: bold;
}
label {
  color: #9A9B9C;
  padding: 5px 0px;
  margin: 0px 20px 0px 0px;
  font-size: 18px;
  font-family: "Lato-Regular", sans-serif;
}
label:hover {
  color: #284D76;
}
.label-error {
  color: #EB0C0C !important;
}
input,
.mat-input {
  font-family: "Gotham-Book", serif;
  color: #333333;
  font-size: 18px;
}
input::placeholder {
  color: #9A9B9C;
}
input[type=text],
input[type=date],
input[type=datetime-local],
input[type=email],
.mat-input,
select {
  margin: 2px 0px;
  width: 324px;
  height: 50px;
  border-radius: 10px;
  border: 1px solid #7376BC;
}
input[type=text]:focus,
input[type=email]:focus,
input[type=date]:focus,
input[type=datetime-local]:focus,
input[type=email]:focus {
  border-radius: 10px;
  border: 1px solid #7FABC7;
  color: #333333;
  box-shadow: none;
}
input[type=radio] {
  margin: 10px;
  color: #333333;
}
.input-error {
  border: 1px solid #EB0C0C !important;
  color: #EB0C0C !important;
}
.input-complete {
  color: #333333 !important;
}
textarea {
  border-radius: 10px;
  padding: 15px;
  font-size: 16px;
  font-family: "Gotham-Book", serif;
}
textarea:hover,
textarea:focus,
textarea:active {
  border-color: #284D76;
}
.custom-input {
  border: none !important;
  outline: none;
  flex: 1;
}
.custom-input-container {
  display: flex;
  flex-direction: row;
  border: 1px solid #5F96BA;
  border-radius: 10px;
  align-items: center;
  background-color: #FFF;
  width: 100%;
}
.custom-input-container:hover {
  border: 1px solid #284D76;
}
.custom-input-container:hover .search-button {
  background-image: url(/assets/img/icons/search_meralco_blue.png);
}
.search-button {
  background-image: url(/assets/img/icons/search.png);
  background-size: cover;
  width: 14px;
  height: 14px;
  position: relative;
  cursor: pointer;
  margin: 18px;
}
.clear-search-button {
  background-image: url(/assets/img/icons/close_button.svg);
  background-size: cover;
  width: 14px;
  height: 14px;
  position: relative;
  cursor: pointer;
  margin: 18px;
}
.custom-input-prefix {
  color: #b7b7b7;
  font-size: 16px;
}
.customer-radio {
  width: 15px;
  height: 15px;
  position: relative;
  background-image: url(/assets/img/icons/radioButton_inactive.svg);
  background-size: cover;
  background-repeat: no-repeat;
  cursor: pointer;
}
.customer-radio-selected {
  background-image: url(/assets/img/icons/radioButton_active.svg);
}
.customer-radio input[type=radio] {
  padding: 0px;
  margin: 0px;
  display: none;
}
.customer-checkbox {
  display: inline-block;
  border-radius: 3px;
  width: 20px;
  height: 20px;
  margin: 5px;
  cursor: pointer;
  background-image: url(/assets/img/icons/checkbox_inactive.svg);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.customer-checkbox-selected {
  background-image: url(/assets/img/icons/checkbox_active.svg);
}
.customer-checkbox input[type=checkbox] {
  padding: 0px;
  margin: 0px;
  width: 100%;
  height: 100%;
  display: none;
}
@media screen and (max-width: 1000px) {
  label {
    margin: 0px;
  }
  input[type=text],
  input[type=date],
  input[type=datetime-local],
  input[type=email],
  select {
    width: 275px;
  }
  .custom-input {
    overflow: hidden;
  }
  .custom-input-container {
    width: 100%;
  }
}
.clear {
  padding: 0px;
  margin: 0px;
}
.img-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-0-inset {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 50;
  box-shadow: inset 100px 50px 50px rgb(255, 255, 255);
}
.banner-1-inset {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 50;
  box-shadow: inset -100px 50px 50px #FFF;
}
.top-banner {
  display: flex;
}
.text-banner-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: flex-start;
  justify-content: center;
  padding: 80px;
}
.text {
  color: #171C8F;
}
.text-lg,
.text-lg-40 {
  font-family: "Gotham-Bold", serif;
  width: 100%;
  text-align: left;
  font-size: 61px;
  color: #284D76;
  padding: 10px;
  letter-spacing: 0px;
  line-height: 1.2;
}
.text-lg-40 {
  font-size: 40px;
}
.text-md {
  font-family: "Lato-Regular", serif;
  font-size: 18px;
  padding: 10px;
  text-align: left;
  color: #333333;
  line-height: 1.5;
}
.services {
  background-color: #ECF3F7;
}
a {
  font-family: Lato-Bold, serif;
  text-decoration: none;
  color: #5F96BA;
}
.redirects {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  padding: 30px !important;
  background-color: #ECF3F7;
}
.card_,
.card_sm {
  width: 382px;
  padding: 38px 29px;
  border-radius: 20px;
  background-color: #FFF;
  margin: 30px;
}
.card_sm {
  width: 304px;
  padding: 30px 20px;
  margin: 10px;
}
.card_title {
  color: #284D76;
  font-size: 18px;
  font-family: "Gotham-Bold", serif;
  margin-bottom: 10px;
}
.card_text {
  font-family:
    "Lato-Regular",
    "Roboto",
    serif;
  font-size: 18px;
  width: 100%;
}
.card_icon {
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
  display: inline-block;
}
@media screen and (max-width: 1000px) {
  .top-banner {
    flex-direction: column-reverse;
  }
  .text-banner-container {
    align-items: center;
    justify-content: center;
    padding: 20px;
    margin-top: 10px;
  }
  .text-lg,
  .text-lg-40 {
    font-size: 25px;
    width: 100%;
  }
  .text-md {
    font-size: 16px;
  }
  .card_sm {
    width: 320px;
    padding: 50px 20px;
  }
  .card_title {
    font-size: 20px;
  }
  .card_text {
    font-size: 16px;
  }
  .banner-0-inset {
    box-shadow: inset 0px -50px 50px 20px rgb(255, 255, 255);
  }
  .banner-1-inset {
    box-shadow: inset 0px -50px 50px 20px rgb(255, 255, 255);
  }
}
/*# sourceMappingURL=landing.component.css.map */
